import React from 'react';
import './Testimonials.css';

// Import customer images
import gishankaImage from '../../assets/customers/gishankasilva.png';
import romeshImage from '../../assets/customers/romeshdesilva.jpg';
import ferozeImage from '../../assets/customers/ferozekamal.png';
import alessandraImage from '../../assets/customers/Alessandra Nahra.jpg';
import naomalImage from '../../assets/customers/naomalwagiswara.png';
import ilzamImage from '../../assets/customers/ilzamlahir.png';

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: 'Gishanka De Silva',
      role: 'Director & CEO @ DG5',
      image: gishankaImage,
      quote: 'Great service and a lot of clever 🙂 home automation solutions. Glad to see a company focusing on this fast growing requirement and having the necessary expertise.'
    },
    {
      name: 'Romesh De Silva',
      role: 'Business Consultant',
      image: romeshImage,
      quote: 'CLEVR team provided an excellent service in installing the latest Cctv cameras. It was a neatly performed task without any visible cables. The installation team worked tirelessly till it was completed.'
    },
    {
      name: 'Feroze Kamal',
      role: 'CEO @ Kraft Dates',
      image: ferozeImage,
      quote: 'The team had extensive knowledge of the latest technology that suited my requirements and had trained personnel to handle the electrical aspects. Together, they provided exactly what I had envisioned.'
    },
    {
      name: 'Alessandra Nahra',
      role: 'Director @ Ceccato Colombo',
      image: alessandraImage,
      quote: 'Clevr Automation has completely transformed my apartment. His masterful problem-solving skills and innovative solutions have made my smart home experience truly exceptional.'
    },
    {
      name: 'Naomal Wagiswara',
      role: 'Captain @ Qatar Airways',
      image: naomalImage,
      quote: 'I am pleased to recommend Clevr Automations for their exceptional Home Automation service. I was consistently impressed by their professionalism and attention to detail.'
    },
    {
      name: 'Ilzam Lahir',
      role: 'Country Director - OSMO',
      image: ilzamImage,
      quote: 'They not only possessed a deep understanding of their products but also provided invaluable insights and practical recommendations tailored to my specific needs.'
    }
  ];

  return (
    <section className="testimonials" id="testimonials">
      <div className="testimonials-container">
        <span className="section-badge">TESTIMONIALS</span>
        <h2 className="testimonials-title">
          Trusted by a Forward Thinking Clientele
        </h2>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-header">
                <div className="testimonial-avatar">
                  <img src={testimonial.image} alt={testimonial.name} />
                </div>
                <div className="testimonial-info">
                  <h4 className="testimonial-name">{testimonial.name}</h4>
                  <p className="testimonial-role">{testimonial.role}</p>
                </div>
              </div>
              <p className="testimonial-quote">{testimonial.quote}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
